import React from 'react';
import LoginSignup from '../pages/LoginSignup';


function SecureRoute(props) {

    if(localStorage.getItem('userId')){
        return props.children
    }else{
        return <LoginSignup/>
    }
}

export default SecureRoute